import cn from 'classnames'
import React from 'react'

import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'

import { LinkConfigType, ToastStyles, ToastType } from '../../types/ToastTypes'

import {
   getToastStyles,
   leftIconClassName,
   toastWithLinkContainerStyles
} from './styles'

import './index.css'

interface ToastComponentProps {
   title: string
   toastType: ToastType
   dismissToast: () => void

   renderLeftIcon?: (color: string) => React.ReactElement

   link: LinkConfigType

   toastClassName?: string
}

export const ToastComponentWithLink = (props: ToastComponentProps) => {
   const {
      title,
      toastType,
      renderLeftIcon,
      link,
      toastClassName,
      dismissToast
   } = props

   const { theme } = useAppTheme()
   const toastTheme = theme.toast
   const {
      bgColor,
      borderColor,
      textColor,
      leftIconColor
   }: ToastStyles = getToastStyles(toastTheme, toastType)

   const handleOnClickLink = (): void => {
      link.onClickLink()
      dismissToast()
   }

   return (
      <div
         className={cn(
            toastWithLinkContainerStyles,
            bgColor,
            borderColor,
            toastClassName
         )}
      >
         <div className={leftIconClassName}>
            {renderLeftIcon ? renderLeftIcon(leftIconColor) : null}
         </div>
         <p
            className={cn(
               'pr-[24px] w-[max-content] text-lg-medium',
               textColor
            )}
         >
            {title}
         </p>
         <Button
            hierarchy={link.linkButtonHierarchy ?? Hierarchy.Link}
            subVariant={link.linkButtonSubVariant ?? SubVariant.Gray}
            size={'Medium'}
            className='ml-auto'
            onClick={handleOnClickLink}
            rightIcon={({ stroke }) => link.renderIcon?.(stroke)}
         >
            {link.label}
         </Button>
      </div>
   )
}
